//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    entry: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    deleteItemConfirm() {
      this.$emit('deleteEntry', this.entry.id);
      this.dialog = false;
    },
  },
};
